export default [
  {
    path: "user",
    name: "Thông tin tài khoản",
    component: () => import("@/views/screens/UserProfile"),
    meta: {
      requiresAuth: true,
      title: "Thông tin tài khoản"
    },
  },
  {
    path: "account_manager",
    name: "Quản lý người dùng",
    component: () => import("@/views/screens/administration/AccountManager"),
    meta: {
      requiresAuth: true,
      title: "Quản lý người dùng"
    },
  },
  {
    path: "employee_manager",
    name: "Quản lý nhân viên",
    component: () => import("@/views/screens/administration/EmployeeManager"),
    meta: {
      requiresAuth: true,
      title: "Quản lý nhân viên"
    },
  },
  {
    path: "role",
    name: "Quản lý quyền",
    component: () => import("@/views/screens/administration/RoleManager"),
    meta: {
      requiresAuth: true,
      title: "Quản lý quyền"
    },
  },
  {
    path: "group_role",
    name: "Quản lý nhóm quyền",
    component: () => import("@/views/screens/administration/GroupRoleManager"),
    meta: {
      requiresAuth: true,
      title: "Quản lý nhóm quyền"
    },
  },
  {
    path: "menu",
    name: "Quản lý menu",
    component: () => import("@/views/screens/administration/MenuManager"),
    meta: {
      requiresAuth: true,
      title: "Quản lý menu"
    },
  },

  {
    path: "departments",
    name: "Quản lý phòng ban",
    component: () =>
      import("@/views/screens/administration/DepartmentsManager"),
    meta: {
      requiresAuth: true,
      title: "Quản lý phòng ban"
    },
  },

  {
    path: "notification",
    name: "Quản lý thông báo",
    component: () =>
      import("@/views/screens/administration/NotificationManager"),
    meta: {
      requiresAuth: true,
      title: "Quản lý thông báo"
    },
  },
];
